import React from "react";
import PayoutCPCheckerDashboard from "../../components/PayoutCPCheckerDashBoard/PayoutCPCheckerDashboard";


const PayoutCPCheckerDashboardContainers = () => {
  return <PayoutCPCheckerDashboard />;
};

export default PayoutCPCheckerDashboardContainers;
